import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Pages } from "./shared/Constants";
import Sidebar from "./components/Sidebar";
import "./App.css";
import { useAuth } from "./context/AuthContext";
import { NavigationItem } from "./shared/models/ui-using/NavigationItem";
import { isAdmin } from "./shared/utils/roles";
import { useIdleTimer } from "./hooks/useIdleTimer";

const menuItems: NavigationItem[] = [
  { key: Pages.dashboard, label: "Dashboard", icon: "📊" },
  { key: Pages.userManagement, label: "User Management", icon: "👥", adminOnly: true },
  { key: Pages.administration, label: "Administration", icon: "⚙️", adminOnly: true },
];

function App() {
  const navigate = useNavigate();
  const { userRoles } = useAuth();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  // Set timeout to 5 minutes (300,000 ms)
  useIdleTimer(5 * 60 * 1000, () => {
    if (window.confirm("You have been idle for 5 minutes. Do you want to go to the dashboard?")) {
      navigate(`/${Pages.dashboard}?reset=true`);
    }
  });

  return (
    <>
      <Sidebar
        defaultMenu={Pages.dashboard}
        menuItems={menuItems}
        onToggle={setIsSidebarCollapsed}
        isAdmin={isAdmin(userRoles)}
      />
      <div className={`main-content ${isSidebarCollapsed ? "sidebar-collapsed" : ""}`}>
        <Outlet />
      </div>
    </>
  );
}

export default App;
